import $ from 'jquery';

const _slice = Array.prototype.slice;

export const isDefined = obj => {
    if (obj === null || typeof obj === 'undefined') return false;

    return true;
};

export const isNumber = obj => {
    if (!isDefined(obj)) return false;

    return obj.constructor === Number;
};

export const isString = obj => {
    if (!isDefined(obj)) return false;

    return obj.constructor === String;
};

export const isObject = obj => {
    if (!isDefined(obj)) return false;

    return obj.constructor === Object;
};

export const isFunction = obj => {
    if (!isDefined(obj)) return false;

    return obj.constructor === Function;
};

export const not = func => {
    if (!isFunction(func)) throw new TypeError('func parameter type of not() must be Function.');

    return function(obj) {
        return !func(obj);
    };
};

export const isNotDef = not(isDefined);

export const allOf = function allOf(/*args*/) {
    const args = _slice.call(arguments);

    return args.every(function(val) {
        return val === true;
    });
};

export const namespace = (namespace, parent) => {
    if (!isString(namespace)) throw new TypeError('namespace parameter type of namespace() must be String.');

    if (!(isObject(parent) || !isDefined(parent))) {
        throw new TypeError('parent parameter type of namespace() must be Object or null or undefined.');
    }

    var ns = parent || window;

    if (namespace) {
        var parts = namespace.split('.');

        for (var i = 0, max = parts.length; i < max; i++) {
            if (!ns[parts[i]]) ns[parts[i]] = {};
            ns = ns[parts[i]];
        }
    }

    return ns;
};

export const getNumberToBiliteralStr = number => {
    if (!isNumber(number)) throw new TypeError('[getNumberToBiliteralStr]: require number parameter.');

    const num = String(number);
    return num.length < 2 ? '0' + num : num;
};

export const getResolution = (breakpoint = { tablet: 640, pc: 960 }, global = window) => {
    let resolution = '';
    if (breakpoint.max && global.innerWidth >= breakpoint.max) {
        resolution = 'max';
    } else if (breakpoint.pc && global.innerWidth >= breakpoint.pc) {
        resolution = 'pc';
    } else if (breakpoint.tablet && global.innerWidth >= breakpoint.tablet) {
        resolution = 'tablet';
    } else {
        resolution = 'phone';
    }

    return resolution;
};

export const isMobileEnv = $body => $body.hasClass('mobile') || $body.hasClass('tablet');

export const isMobileResolution = resolution => {
    return resolution === 'phone' || resolution === 'tablet';
};

export const isSlickWrapInitialized = $wrap => {
    if ($wrap.length) return $wrap.hasClass('slick-initialized');

    return false;
};

export const getCookie = name => {
    let cookieArr = document.cookie.split('; '),
        splitArr = [],
        keyStr = '',
        valueStr = '';

    for (let i = 0, max = cookieArr.length; i < max; ++i) {
        splitArr = cookieArr[i].split('=');
        keyStr = splitArr[0];
        valueStr = unescape(splitArr[1]);

        if (keyStr === name) return valueStr;
    }

    return '';
};

export const setCookie = (name, value, expiredays, path, domain) => {
    const date = new Date();
    date.setDate(date.getDate() + expiredays);

    const pathStr = '; path=' + (path ? path : '/'),
        domainStr = '; domain=' + (domain ? domain : '.plaync.com'),
        expiresStr = '; expires=' + date.toGMTString();

    document.cookie = name + '=' + escape(value) + pathStr + domainStr + expiresStr;
};

export const isDecodedUri = uri => {
    return window.decodeURIComponent(uri) === uri;
};

export const getDecodedUriParams = decodedUri => {
    if (!isString(decodedUri)) throw new TypeError('getDecodedUriParams() requires String parameter.');

    if (decodedUri.length < 1) return null;
    decodedUri = decodedUri.split('#')[0];

    let tmpArr = decodedUri.split('?');
    if (tmpArr.length < 2) return null;

    const paramStr = tmpArr[1],
        params = paramStr.split('&');

    let obj = {};
    for (let param, keyStr = '', valueStr = '', i = 0, max = params.length; i < max; ++i) {
        param = params[i];

        const eqIndex = param.indexOf('=');
        if (eqIndex >= 0) {
            keyStr = param.substr(0, eqIndex);
            valueStr = param.substr(eqIndex + 1);

            obj[keyStr] = valueStr;
        }
    }

    return obj;
};

export const getReencodedUriParams = uri => {
    let params = {};

    if (isDecodedUri(uri)) {
        console.log('decoded url');

        // decoded url
        params = getDecodedUriParams(uri);
    } else {
        // encoded url
        console.log('encoded url');

        const decodedUrl = window.decodeURIComponent(uri);
        console.log('decode encoded url :', decodedUrl);

        params = getDecodedUriParams(decodedUrl);
    }

    // encode parameter values
    for (let i in params) params[i] = window.encodeURIComponent(params[i]);

    return params;
};

export const getUriParams = uri => {
    if (!isString(uri)) throw new TypeError('getUriParams() requires String parameter.');

    if (uri.length < 1) return null;
    uri = uri.split('#')[0];

    let tmpArr = uri.split('?');
    if (tmpArr.length < 2) return null;

    const paramStr = tmpArr[1],
        params = paramStr.split('&');

    let obj = {};
    for (let keyValueArr, i = 0, max = params.length; i < max; ++i) {
        keyValueArr = params[i].split('=');
        if (keyValueArr.length <= 1) return null;

        obj[keyValueArr[0]] = keyValueArr[1];
    }

    return obj;
};

export const getUriCombinedParams = (uri, parameters) => {
    if (!isString(uri)) throw new TypeError('uri parameter type of getUriCombinedParams() must be String.');

    if (!isObject(parameters))
        throw new TypeError('parameters parameter type of getUriCombinedParams() must be Object.');

    if (!uri) return '';
    if (!parameters) return uri;

    var str = '';
    for (var key in parameters) {
        str += '&' + key + '=' + String(parameters[key]);
    }

    if (str === '') return uri;

    var tmpArr = uri.split('#'),
        hashStr = isDefined(tmpArr[1]) ? '#' + tmpArr[1] : '';

    uri = tmpArr[0];
    uri = (uri.indexOf('?') >= 0 ? uri + str : uri + '?' + str.substr(1)) + hashStr;

    return uri;
};

export const hasNotNumber = str => {
    if (!isString(str)) throw new TypeError('[hasNotNumber]: require string parameter.');

    const matchesNotNumber = str.match(/[^0-9]/g);
    return Array.isArray(matchesNotNumber);
};

// export const checkPhoneNumberWhenInputKeyUp = evt => {
//     const input = evt.target;
//
//     if (hasNotNumber(input.value)) {
//         window.alert(msg.INPUT_PROPER_PHONE_NUMBER); // 올바른 핸드폰 번호를 입력해주세요.
//
//         input.value = input.value.replace(/[^0-9]/g, '');
//
//         return false;
//     }
//
//     return true;
// };

export const isProperPhoneNumberFormat = (phoneType, telNumberStr) => {
    if (!isString(phoneType))
        throw new TypeError('[isProperPhoneNumberFormt]: phoneType parameter type must be String.');
    if (!isString(telNumberStr))
        throw new TypeError('[isProperPhoneNumberFormt]: telNumberStr parameter type must be String.');

    if ((phoneType !== '010' && telNumberStr.length < 7) || (phoneType === '010' && telNumberStr.length < 8))
        return false;

    const matchesNotNumber = telNumberStr.match(/[^0-9]/g);
    if (Array.isArray(matchesNotNumber)) return false;

    return true;
};

export const getCheckedOSTypeInCheckCouponLayer = $wrap => {
    const checkedRadioBtn = $('.store-area input[type=radio]', $wrap).filter(function(index, element) {
        return $(element).prop('checked') === true;
    });

    if (checkedRadioBtn.length) {
        return checkedRadioBtn.get(0).id === 'ly-android' ? 1 : 2;
    }

    return -1;
};

export const getCouponNumberRegex = () => {
    return /couponNo=([^,]*)/;
};

export const copyTextToClipboardFallback = (text, doneCallback = null, failCallback = null) => {
    if (isDefined(doneCallback) && !isFunction(doneCallback))
        throw TypeError(
            'doneCallback parameter type of copyTextToClipboardFallback() must be undefined or null or Function.'
        );
    if (isDefined(failCallback) && !isFunction(failCallback))
        throw TypeError(
            'failCallback parameter type of copyTextToClipboardFallback() must be undefined or null or Function.'
        );

    const textArea = document.createElement('textarea');
    textArea.style.position = 'fixed';
    textArea.style.top = '-9999px';
    textArea.style.left = '-9999px';
    textArea.style.width = '2em'; // Ensure it has a small width and height. Setting to 1px / 1em doesn't work as this gives a negative w/h on some browsers.
    textArea.style.height = '2em';
    textArea.value = text;
    document.body.appendChild(textArea);

    textArea.focus();
    textArea.select();

    try {
        const isSuccessCopy = document.execCommand('copy');
        if (isSuccessCopy) {
            if (doneCallback) doneCallback.call(null, text);
            return;
        }

        if (failCallback) failCallback.call(null, new Error(''));
    } catch (error) {
        if (failCallback) failCallback.call(null, error);
    }

    document.body.removeChild(textArea);
};

export const copyTextToClipboard = (text, doneCallback = null, failCallback = null) => {
    if (isDefined(doneCallback) && !isFunction(doneCallback))
        throw TypeError('doneCallback parameter type of copyTextToClipboard() must be undefined or null or Function.');
    if (isDefined(failCallback) && !isFunction(failCallback))
        throw TypeError('failCallback parameter type of copyTextToClipboard() must be undefined or null or Function.');

    if (!navigator.clipboard) {
        copyTextToClipboardFallback(text, doneCallback, failCallback);
    } else {
        // https://developer.mozilla.org/en-US/docs/Web/API/Clipboard
        navigator.clipboard.writeText(text).then(
            () => {
                doneCallback.call(null, text);
            },
            error => {
                failCallback.call(null, error);
            }
        );
    }
};

export const remap = (_targetValueFloat, _minValueFloat, _maxValueFloat, _remapMinValueFloat, _remapMaxValueFloat) => {
    return (
        (_targetValueFloat - _minValueFloat) *
            (_remapMaxValueFloat - _remapMinValueFloat) /
            (_maxValueFloat - _minValueFloat) +
        _remapMinValueFloat
    );
};
